import { getBookingMastersTableData } from '../../api/BookingMasters';
import { deleteAllocationRules } from '../../api/CarrierPartner';

const addUpdateOptions = [
  {
    key: 'single_entry',
    title: 'Single Entry',
    action: 'addSingleRule',
    type: 'singleRule',
  },
  {
    key: 'excel_upload',
    title: 'Excel Upload',
    action: 'update',
    type: 'bulk',
  },
];

const viewControl = {
  pageTitle: 'Setup',
  buckets: ['courierPricing', 'courierTat', 'courierDestinationType', 'courierHoliday', 'courierServiceability', 'courierLocationType', 'courierLocationGroup'],
  globalActions: [],
  fetchData: getBookingMastersTableData,
  bulkDeleteMultiple: deleteAllocationRules,
  addUpdateOptions: addUpdateOptions,
};
const buckets = {
  courierPricing: {
    name: 'Rate Master',
    filters: [],
    actions: [
      {
        key: 'addUpdate',
        name: 'Add or Update',
      },
      {
        key: 'bulk_delete',
        name: 'Delete',
      },
      {
        key: 'pagination',
        name: 'Pagination',
      },
      {
        key: 'download',
        name: 'Download',
      },
      {
        key: 'reload',
        name: 'Reload',
      },
    ],
  },
  courierTat: {
    name: 'TAT Master',
    filters: [],
    actions: [
      {
        key: 'addUpdate',
        name: 'Add or Update',
      },
      {
        key: 'bulk_delete',
        name: 'Delete',
      },
      {
        key: 'pagination',
        name: 'Pagination',
      },
      {
        key: 'download',
        name: 'Download',
      },
      {
        key: 'reload',
        name: 'Reload',
      },
    ],
  },
  courierDestinationType: {
    name: 'Destination Type',
    actions: [
      {
        key: 'addUpdate',
        name: 'Add or Update',
      },
      {
        key: 'bulk_delete',
        name: 'Delete',
      },
      {
        key: 'pagination',
        name: 'Pagination',
      },
      {
        key: 'download',
        name: 'Download',
      },
      {
        key: 'reload',
        name: 'Reload',
      },
    ],
  },
  courierServiceability: {
    name: 'Serviceability Master',
    actions: [
      {
        key: 'addUpdate',
        name: 'Add or Update',
      },
      {
        key: 'bulk_delete',
        name: 'Delete',
      },
      {
        key: 'pagination',
        name: 'Pagination',
      },
      {
        key: 'download',
        name: 'Download',
      },
      {
        key: 'reload',
        name: 'Reload',
      },
    ],
  },
  courierHoliday: {
    name: 'Holiday Master',
    filters: [],
    actions: [
      {
        key: 'addUpdate',
        name: 'Add or Update',
      },
      {
        key: 'bulk_delete',
        name: 'Delete',
      },
      {
        key: 'pagination',
        name: 'Pagination',
      },
      {
        key: 'download',
        name: 'Download',
      },
      {
        key: 'reload',
        name: 'Reload',
      },
    ],
  },
  courierLocationType: {
    name: 'Location Master',
    filters: [],
    actions: [
      {
        key: 'addUpdate',
        name: 'Add or Update',
      },
      {
        key: 'bulk_delete',
        name: 'Delete',
      },
      {
        key: 'pagination',
        name: 'Pagination',
      },
      {
        key: 'download',
        name: 'Download',
      },
      {
        key: 'reload',
        name: 'Reload',
      },
    ],
  },
  courierLocationGroup: {
    name: 'Location Group Master',
    filters: [],
    actions: [
      {
        key: 'update',
        name: 'Update',
      },
      {
        key: 'bulk_delete',
        name: 'Delete',
      },
      {
        key: 'download',
        name: 'Download',
      },
      {
        key: 'reload',
        name: 'Reload',
      },
    ]
  },
  advancedSettings: {
    name: 'Advanced Settings',
    filters: [],
    actions: [],
  },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };
